import { MAX_SIGNATURE_LENGTH } from '../../modals/ShareViaEmailModal/emailFormSchema';

type ResolveSignatureAfterEditParams = {
  draft: string;
  initialSignature: string;
  currentSignature: string | null;
  defaultSignature: string | undefined;
};

export const resolveSignatureAfterEdit = ({
  draft,
  initialSignature,
  currentSignature,
  defaultSignature,
}: ResolveSignatureAfterEditParams): string | null => {
  if (defaultSignature !== undefined && draft.trim() === defaultSignature.trim()) return null;
  return draft === initialSignature ? currentSignature : draft;
};

export const canConfirmSignatureDraft = (draft: string) =>
  draft.trim().length > 0 && draft.length <= MAX_SIGNATURE_LENGTH;
